<template>
  <div>
    <section-header ja="会員証" en="Member">
      <img src="@/assets/Png/title/member.png">
    </section-header>
    <div class="textArea">
      <p>
        現在会員証のメンテナンス中の為<br>
        ご利用いただくことができません
      </p>
    </div>

    <div class="linkArea">
      <div class="descliption">会員証を使わずに撮影した場合は、「プリダウンロード」からシールIDを入力することでアルバムにダウンロードできます。</div>
      <normal-btn @click="onDownload">プリダウンロード</normal-btn>
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
import NormalBtn from '@/components/NormalBtn.vue'
import Screen from '@/mixins/screen.js'
import Protobuf from '@/mixins/protobuf.js'
import {genBase62} from '../assets/js/util'

import QRCode from 'qrcode'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Member",
  components: { SectionHeader, NormalBtn },
  mixins: [Screen, Protobuf],
  props: {
    fromError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      onboarding: 0,
      hasCover: true,
      limitTime: "",
      limitDate: null,
    }
  },
  computed: {
    qrcodeImgStyle () {
      const w = this.lengthAtDevice(487) + 'px'
      return {
        position: 'relative',
        height: w,
        width: w,
        userSelect: 'none'
      }
    },
    a0ImgStyle () {
      return Object.assign({ opacity: 0 }, this.qrcodeImgStyle)
    },
    smokeStyle () {
      const w = this.lengthAtDevice(487) + 'px'
      return {
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: w,
        width: w,
      }
    },
    reBtnImgStyle () {
      const w = this.lengthAtDevice(487) + 'px'
      return {
        height: w,
        width: w
      }
    }
  },
  methods: {
    onRight() {
    },
    preventScreenshot() {
      document.addEventListener('keydown', e => { this.hasCover = e.keyCode != undefined }, false)
    },
    preventRightClick() {
      this.tags('qr-code').forEach(tag => {
        tag.addEventListener('contextmenu', e => e.preventDefault(), false)
      })
    },
    preventDragAndDrop() {
      this.tags('qr-code').forEach(tag => {
        tag.addEventListener('mousedown', e => e.preventDefault(), false)
      })
    },
    tags(className) {
      return Array.from(document.getElementsByClassName(className))
    },
    onAlbum() {
      this.$router.push('/album')
    },
    onDownload() {
      this.$router.push('/download')
    },
    onCoupon() {
      this.$router.push('/couponList')
    },
    onCover() {
      this.getQrCode(441)
    },
    setLimitTime(date) {
      const padding = function (num) {
        return ('0' + num).slice(-2)
      }
      const y = date.getFullYear()
      const m = padding(date.getMonth() + 1)
      const d = padding(date.getDate())
      const h = padding(date.getHours())
      const min = padding(date.getMinutes())

      this.limitTime = `${y}.${m}.${d} ${h}:${min}`
    },
    getQrCode(code) {
      const cmdNo = pb.PlayerDigitalPassReq.CommandNo.COMMAND_NO
        // limitSecs
        // digitalPass
      const message = pb.LoginReq.create({})
      const encoded = pb.LoginReq.encode(message).finish()
      const component = this
      this.post(cmdNo, encoded)
        .then(decoded => {
          const strQRcode = genBase62(decoded.digitalPass)
          QRCode.toCanvas(this.$refs.qrcode, strQRcode, {
            version: 4,
            margin: 2,
            scale: 10,
            errorCorrectionLevel: 'H'
          }, function (err) {
            if (err) {
              component.$router.push('/error/会員証/'+code)
              return
            }
            let date = new Date()
            date.setSeconds(date.getSeconds() + decoded.limitSecs)
            component.setLimitTime(date)

            if (decoded.limitSecs > 0) {
              component.limitDate = date
              component.hasCover = false
            }
          })
        })
        .catch(() => {
          this.$_error('Error', { title: '会員証', statusCode: 100 })
        })
    },
    checkLimitDate() {
      if (this.limitDate == null) {
        return
      }
      const now = new Date().getTime()
      const dst = this.limitDate.getTime()
      this.hasCover = dst < now
    }
  },
  mounted() {
    this.preventScreenshot()
    if (!this.fromError) {
      this.getQrCode(440)
    }
    setInterval(() => {
      this.preventRightClick()
      this.preventDragAndDrop()
      this.checkLimitDate()
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.qr-code-section {
  position: relative;
  margin: 30px 0px 10px 0px;
}
.back {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-code {
  width: 180px !important;
  height: 180px !important;
}
.front {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .hasCover {
    background: rgba(255, 255, 255, 0.8);
    width: 170px;
    height: 170ppx;
    padding: 10px;
    & > img { width: 150px; }
  }
}
.qr-code-limit {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-code-limit img {
  margin-right: 4px;
  height: 14px;
  width: 14px;
}
.qr-code-limit-text {
  color: #5F96C9;
  font-size: 12px;
}
.textArea {
  text-align: center;
  margin: 60px 0 30px;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.linkArea {
  padding-top: 30px;
}
.descliption {
  margin-top: 30px;
  padding: 0 30px;
  font-size: 12px;
  color: #373737;
}
</style>
